var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/menu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5,31 C35.3284271,31 36,31.6715729 36,32.5 C36,33.3284271 35.3284271,34 34.5,34 L15.5,34 C14.6715729,34 14,33.3284271 14,32.5 C14,31.6715729 14.6715729,31 15.5,31 L34.5,31 Z M34.5,24 C35.3284271,24 36,24.6715729 36,25.5 C36,26.3284271 35.3284271,27 34.5,27 L15.5,27 C14.6715729,27 14,26.3284271 14,25.5 C14,24.6715729 14.6715729,24 15.5,24 L34.5,24 Z M34.5,17 C35.3284271,17 36,17.6715729 36,18.5 C36,19.3284271 35.3284271,20 34.5,20 L15.5,20 C14.6715729,20 14,19.3284271 14,18.5 C14,17.6715729 14.6715729,17 15.5,17 L34.5,17 Z",
    id: "Combined-Shape",
    fill: "#1C1D1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e73a47f39f1261a092f86448908c1122.svg";
export { ForwardRef as ReactComponent };